/*----- Core -----*/
import React                        from "react"
import { Route, Switch , Redirect } from "react-router"
import { withRouter }							  from "react-router"

/*----- Components -----*/

/*----- Nav Components -----*/
import Header	from "../../components/commons/nav/Header"
import Footer from "../../components/commons/nav/Footer"

/*----- Modules -----*/
import Home      		from "../home/index"
import Contact   		from "../contact/index"
import Login     		from "../login/index"
import Producers 		from "../producers/index"
import Admin      	from "../admin/index"
import OurHome    	from "../our-home/index"
import LandingReggi from "../producer_landing_page/index"
import IntivaFooter from "../../components/commons/nav/IntivaFooter"


const ViewsContainer = ({ location }) => {

	const userIsLoggedIn = localStorage.getItem('userIsLoggedIn') === 'true'

	const PrivateRoute = ({ component: Component, ...rest }) => (
		<Route {...rest} render={(props) => (
			userIsLoggedIn
				? <Component {...props} />
				: <Redirect to='/login' />
		)} />
	)

	const isLandingPage = () => {
		return location.pathname === "/andres_reggi"
	}

	return (
		<>
			{ isLandingPage()? null : <Header />}
			<Switch>
				{/*** Public routes ***/}
				<Route exact path="/"     		 component = { Home } />
				<Route exact path="/our-home"  component = { OurHome } />
				<Route exact path="/contact"   component = { Contact } />
				<Route exact path="/producers" component = { Producers } />
				<Route exact path="/login"  	 render    = { () => userIsLoggedIn? (<Redirect to="/admin"/>) : <Login /> }/>	
				{/*** Admin routes ***/}
				<PrivateRoute path="/admin" component={ Admin } />
				{/*** Landing page Reggi ***/}
				<Route exact path="/andres_reggi" component = { LandingReggi } />
			</Switch>
			{ !isLandingPage()? <Footer /> : 	<IntivaFooter /> }
		</>
	)
}
export default withRouter(ViewsContainer)